@use "../../sass/variables/typography";
@use "../../sass/mixins/font-family";

:host {
    display: block;
}

@mixin responsive-font-sizes($size-xl, $size-l, $size-m: false, $size-s: false) {
    font-size: $size-l;

    @media only screen and (width >=1920px) {
        font-size: $size-xl;
    }

    @if $size-m !=false {
        @media only screen and (width <=1439px) {
            font-size: $size-m;
        }
    }

    @if $size-s !=false {
        @media only screen and (width <=767px) {
            font-size: $size-s;
        }
    }
}

:host([variant="vast"]) {
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
    @include responsive-font-sizes(typography.$size-headline-vast, typography.$size-headline-giant, typography.$size-headline-big, typography.$size-headline-medium);
}

:host([variant="giant"]) {
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
    @include responsive-font-sizes(typography.$size-headline-giant, typography.$size-headline-big, typography.$size-headline-medium, typography.$size-headline-small);
}

:host([variant="big"]) {
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    @include responsive-font-sizes(typography.$size-headline-big, typography.$size-headline-medium, typography.$size-headline-small, typography.$size-headline-small-mobile);
}

:host([variant="medium"]) {
    margin-block-start: 1em;
    margin-block-end: 1em;
    @include responsive-font-sizes(typography.$size-headline-medium, typography.$size-headline-small, typography.$size-headline-small-mobile);
}

:host([variant="small"]) {
    margin-block-start: 1em;
    margin-block-end: 1em;
    line-height: typography.$line-height-small;
    @include responsive-font-sizes(typography.$size-headline-small, typography.$size-headline-small-mobile);
}

:host([strong]) {
    @include font-family.font(bold);
}